import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Input from '../../../../../shared/FormControls/Input'

const FormItem = ({ label, field, validate, clearInput, validationError }) => (
  <Fragment>
    {Object.keys(field).length > 0 && field.name !== 'iataCode' ? (
      <div className={cn('code-form__item', validationError && 'code-form__item--error')}>
        {label && label.length ? (
          <label htmlFor={field.name} className="code-form__item__label">
            {label}
          </label>) : null }

        <Input
          {...field}
          validate={validate}
          withButton={{
            clearButton: true,
            inputName: field.name,
            className: 'clear-input',
            onClickFunc: clearInput,
          }}
        />
      </div>
    ) : null }
  </Fragment>
)

FormItem.propTypes = {
  label: PropTypes.string,
  field: PropTypes.objectOf(Object).isRequired,
  validate: PropTypes.arrayOf(PropTypes.func),
  clearInput: PropTypes.func.isRequired,
}

FormItem.defaultProps = {
  label: '',
  validate: [() => {}],
}

export default FormItem
